export default "__VITE_ASSET__D97rHX0s__"